import { FC } from "react"

import { ReactComponent as IconCheck } from "@common_assets/svg/check-curved.svg"
import { Box } from "@mui/material"
import IconWrapper from "components/common/icon/iconWrapper"
import { unstyledButtonSx } from "styles/common/button"

interface IProps {
  avatarUrl: string
  isChecked: boolean
  onClick: () => void
  ariaLabel: string
}

const AvatarItem: FC<IProps> = ({ avatarUrl, isChecked, onClick, ariaLabel }) => {
  return (
    <Box
      component="button"
      type="button"
      aria-label={ariaLabel}
      aria-pressed={isChecked}
      onClick={onClick}
      sx={(theme) => ({
        ...unstyledButtonSx,
        p: isChecked ? "6px" : "8px",
        borderRadius: "4px",
        border: isChecked
          ? `2px solid ${theme.palette.mockup.neutral0}`
          : "none",
        position: "relative",
        display: "flex",
      })}
    >
      {isChecked && (
        <IconWrapper
          color="mockup.neutral0"
          position="absolute"
          top="-8px"
          right="-8px"
          width="16px"
          height="16px"
        >
          <IconCheck />
        </IconWrapper>
      )}
      <Box
        height="44px"
        width="44px"
        component="img"
        src={avatarUrl}
        alt="avatar"
      />
    </Box>
  )
}

export default AvatarItem
